import React, { FC, Fragment } from 'react';
import { PermissionMatrixProps } from './types';
import {
  MatrixContainerStyled,
  TableStyled,
  HeaderStyled,
  TableRowHeaderStyled,
  TableHeaderStickyStyled,
  headerColumnWidth,
  columnWidth,
  HeaderContainerStlyed,
} from './styled';
import MatrixItem from './item';
import { map } from 'lodash';

export const PermissionMatrix: FC<PermissionMatrixProps> = ({
  selectedRoles,
  rolePermissionScopeList,
  onScopeSelect,
  moduleList,
  collapseModules,
  onExpandCollapseModule,
}) => {
  return (
    <MatrixContainerStyled>
      <TableStyled>
        <thead>
          <TableRowHeaderStyled>
            {/* With 1 role, width is working and with multiple roles minWidth is working otherwise roles are jumping. */}
            <TableHeaderStickyStyled style={{ width: headerColumnWidth, minWidth: headerColumnWidth }} />
            <TableHeaderStickyStyled>
              <HeaderContainerStlyed>
                {map(selectedRoles, (item) => {
                  return (
                    <HeaderStyled style={{ width: columnWidth }} key={item.id}>
                      {item.name}
                    </HeaderStyled>
                  );
                })}
              </HeaderContainerStlyed>
            </TableHeaderStickyStyled>
          </TableRowHeaderStyled>
        </thead>
        <tbody>
          <Fragment>
            {map(moduleList, (moduleItem, moduleIndex) => {
              return (
                <MatrixItem
                  moduleIndex={moduleIndex}
                  moduleItem={moduleItem}
                  selectedRoles={selectedRoles}
                  key={moduleItem.id}
                  rolePermissionScopeList={rolePermissionScopeList}
                  onScopeSelect={onScopeSelect}
                  collapseModules={collapseModules}
                  onExpandCollapseModule={onExpandCollapseModule}
                />
              );
            })}
          </Fragment>
        </tbody>
      </TableStyled>
    </MatrixContainerStyled>
  );
};
